var front_url;
var back_url;
var back_url_chat;

const DEV:any = false;


if (DEV == true) {
    back_url = 'http://localhost:3005'
    back_url_chat = 'http://localhost:5555'
    front_url = 'http://localhost:7777'
    // console.log(host);
}
else if (DEV == false) {
    back_url = 'https://openinnovationchallenges.h2020response.eu/services'
    back_url_chat = 'https://openinnovationchallenges.h2020response.eu/chat'
    front_url = 'https://openinnovationchallenges.h2020response.eu'
    // console.log(host);
}

export const ip_setup = back_url;
export const chat_setup = back_url_chat;
export const front_setup = front_url;
// console.log("FINAL:", ip_setup);

